import { Box, Stack } from '@chakra-ui/react';
import { ProductCategory } from '@diamond/shared/types';
import { Dropdown, Text } from '@diamond/shared/ui';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import {
  getProductFilterRoute,
  getProductFilters,
} from './useProductFilters';

export type MappedSubCategoryData = {
  label: string;
  value: string;
  name: string;
  product_count: number;
  third_category: {
    name: string;
    category_lv3: string;
    product_count: number;
  }[];
};

export type MappedSubCategoryLv3Data = {
  label: string;
  value: string;
  name: string;
  product_count: number;
};

interface FilterSubCategoryProps {
  categoryDatas: ProductCategory[];
  subCategoryData: MappedSubCategoryData[];
  subCategoryLv3Data: MappedSubCategoryLv3Data[];
}

type FormValues = {
  cat2?: string;
  cat3?: string;
};

export const FilterSubCategory: FC<FilterSubCategoryProps> = ({
  categoryDatas,
  subCategoryData,
  subCategoryLv3Data,
}) => {
  const { pathname, query, push } = useRouter();
  const filters = getProductFilters(query);
  const selectedMainCategory = filters.category_lv1;
  const selectedSubCategory = filters.category_lv2;
  const selectedSubCategoryChild = filters.category_lv3;

  const { register, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      cat2: selectedSubCategory,
      cat3: selectedSubCategoryChild,
    },
    values: {
      cat2: selectedSubCategory,
      cat3: selectedSubCategoryChild,
    },
  });

  const submitHandlerCat1 = (value: string) => {
    push(
      getProductFilterRoute(pathname, query, {
        cat1: value,
        cat2: null,
        cat3: null,
        page: 1,
      }),
      undefined,
      { shallow: true }
    );
  };

  const submitHandlerCat2: SubmitHandler<FormValues> = (data) => {
    const { cat2 } = data;
    push(
      getProductFilterRoute(pathname, query, { cat2, cat3: null, page: 1 }),
      undefined,
      { shallow: true }
    );
  };

  const submitHandlerCat3: SubmitHandler<FormValues> = (data) => {
    const { cat3 } = data;
    push(
      getProductFilterRoute(pathname, query, { cat3, page: 1 }),
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <Box
        p="3"
        border="1px"
        overflowY="auto"
        h="250px"
        borderColor="gray.33"
        rounded="lg"
        fontSize="16px"
        display={{ base: 'none', lg: 'block' }}
      >
        <Stack direction="column" id="filter-sub-categories">
          {categoryDatas.map((val, idx: number) => {
            const isActive = selectedMainCategory === val.id;
            return (
              <Box
                flex="1"
                w="full"
                key={idx}
                rounded="lg"
                p="2"
                cursor="pointer"
                bg={isActive ? 'blue' : 'white'}
                color={isActive ? 'white' : 'black'}
                _hover={{ bg: 'cyan', color: 'white' }}
                onClick={() => submitHandlerCat1(val.id)}
              >
                {val.name} ({val.product_count})
              </Box>
            );
          })}
        </Stack>
      </Box>

      {selectedMainCategory && (
        <Box
          p="3"
          border="1px"
          overflowY="auto"
          h={selectedSubCategory ? '160px' : '110px'}
          borderColor="gray.33"
          rounded="lg"
          fontSize="16px"
          display={{ base: 'none', md: 'unset' }}
        >
          <Text fontWeight="bold">Category</Text>
          <Box flex="1" mt="4">
            <form
              onSubmit={handleSubmit(submitHandlerCat2)}
              onChange={handleSubmit(submitHandlerCat2)}
            >
              <Dropdown
                name="cat2"
                placeholder="Semua"
                size="md"
                items={subCategoryData}
                register={register}
              />
            </form>

            {selectedSubCategory && (
              <form
                onSubmit={handleSubmit(submitHandlerCat3)}
                onChange={handleSubmit(submitHandlerCat3)}
              >
                <Dropdown
                  mt="2"
                  name="cat3"
                  placeholder="Semua"
                  size="md"
                  items={subCategoryLv3Data}
                  register={register}
                />
              </form>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
